import { render, staticRenderFns } from "./ListPqr.vue?vue&type=template&id=08e882fa&"
import script from "./ListPqr.vue?vue&type=script&lang=js&"
export * from "./ListPqr.vue?vue&type=script&lang=js&"
import style0 from "./ListPqr.vue?vue&type=style&index=0&id=08e882fa&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports